<template>
	<div class="truefalse" v-if="game">
		<div class="truefalse-questions" v-if="game.questions">
			<div class="truefalse-questions-header flex flex-row justify-end text-xs font-main-bold mb-3">
				<span class="w-16">VRAI</span>
				<span class="w-16">FAUX</span>
			</div>

			<div class="truefalse-question text-left text-sm mb-4" v-for="(question, index) in game.questions" :key="question.id">

				<div class="truefalse-question-content flex flex-row rounded-md overflow-hidden">
					<div class="flex-shrink-0 bg-blue flex items-center justify-center w-8 py-3">
						<span class="text-white">
							{{index + 1}}
						</span>
					</div>

					<span class="truefalse-question-text flex-grow ml-4 py-3">
						{{question.text}}
					</span>

					<div class="truefalse-question-answers flex flex-row items-center justify-center" :class="{ 'right-answer': showCorrection && (isRight(question) === true), 'wrong-answer': showCorrection && (isRight(question) !== true) }">
						<span class="truefalse-question-answer-true w-16" :class="{'is-answer': showCorrection && (isRight(question) === 0)}">
							<input type="radio" :name="'answer-' + index" value="0"
							v-model="answers[question.id]" :disabled="showCorrection">
						</span>
						<span class="truefalse-question-answer-false w-16" :class="{'is-answer': showCorrection && (isRight(question) === 1)}">
							<input type="radio" :name="'answer-' + index" value="1"
							v-model="answers[question.id]" :disabled="showCorrection">
						</span>
					</div>
				</div>

				<div class="truefalse-question-correction rounded-b-md py-3 px-4 ml-8 mr-5" v-show="showCorrection && question.correction"
				:class="{
					'bg-blue-light': (isRight(question) === true),
					'bg-blue-light-gray': (isRight(question) !== true)
				}">
					<div class="uppercase font-black">réponse :</div>
					<div>{{question.correction}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'TrueFalse',
		props: {
			game: {
				type: Object,
				required: false,
				default: null
			},
			showCorrection: {
				type: Boolean,
				required: false,
				default: false
			}
		},
		data(){
			return {
				answers: {},
			}
		},
		watch: {
			game: {
				handler() {
					// Reset states
					this.answers = {}
				},
				immediate: true,
			},
		},
		methods: {
			isRight(question) {
				const answer = ((question.answers && question.answers[0] && question.answers[0].is_correct) ? 0 : 1);
				// TODO: improve, too much calls, maybe ad this to validation data array ?
				return ((this.answers[question.id] !== undefined && this.answers[question.id] == answer) ? true : answer)
			},
			getResults() {
				let results = {
					right: 0,
					wrong: 0,
					total: this.game.questions.length,
				}

				// Compare all user answers to correct answers
				for (var i = 0; i < this.game.questions.length; i++) {
					const question = this.game.questions[i]

					if (this.isRight(question) === true) {
						results.right += 1
					} else {
						results.wrong += 1
					}
				}

				return results
			},
		},
	}
</script>

<style lang="scss" scoped>

label, input  {
	display: block;
	cursor: pointer;
}

input  {
	@apply appearance-none rounded border border-gray;
	width: 16px;
	height: 16px;
	margin: auto;
	
	&:checked {
		@apply border-blue;
		background: url("../../../../assets/images/check-symbol-blue.svg") no-repeat center;
		background-size: 8px 8px;
	}
}

.truefalse-question-content {
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
}

.right-answer {
	input:checked {
		@apply bg-green;
		background-image: url("../../../../assets/images/check-symbol-white.svg");
		background-repeat: no-repeat;
		background-position: center;
		background-size: 8px 8px;
	}
}

.wrong-answer {
	input {
		@apply bg-red border-red;
		background-image: url("../../../../assets/images/check-symbol-white.svg");
		background-repeat: no-repeat;
		background-position: center;
		background-size: 8px 8px;
	}

	.is-answer {
		input {
			@apply bg-green border-green;
			background-image: none;
		}
	}
}

</style>
